import React, { useCallback } from 'react'
import Countdown from 'react-countdown'

export default ({ date, completion }) => {
  const countdownRenderer = useCallback(
    ({ days, hours, minutes, seconds, completed }) => {
      if (completed) return completion
      if (days) return <span>{days} Days</span>
      return (
        <span>
          {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:
          {String(seconds).padStart(2, '0')}
        </span>
      )
    },
    [completion]
  )

  return <Countdown date={date} renderer={countdownRenderer} />
}
